<template>
  <div class="indeCenF">
    <h2>五大服务项目</h2>
    <ul>
      <li>
        <img src="../assets/img/fu-cen1.png" alt="产品服务">
        <h4>产品服务</h4>
        <p>专注移动通信领域，为客户提供便捷、优惠的线上通信业务产品和办理场景服务。产品涵盖流量、充值、套餐、宽带号卡等全量业务</p>
      </li>
      <li>
        <img src="../assets/img/fu-cen2.png" alt="技术研发">
        <h4>技术研发</h4>
        <p>自主研发多套行业一站式通信产品服务平台，与多个行业TOP平台一点对接，具备对运营商的按级赋能能力。平台包括电子渠道综合管理平台、电子渠道销售平台、电子渠道客户服务平台等。同时是阿里钉钉的应用服务商。</p>
      </li>
      <li>
        <img src="../assets/img/fu-cen3.png" alt="互联网营销">
        <h4>互联网营销</h4>
        <p>针对通信类产品，从产品包装、营销策划、渠道推广、功能开发等全流程，提供完整的互联网营销解决方案。</p>
      </li>
      <li>
        <img src="../assets/img/fu-cen4.png" alt="业务创新">
        <h4>业务创新</h4>
        <p>整合最新互联网产品资源和应用场景，与运营商产品深度结合，推出创新型通信增值业务产品服务。</p>
      </li>
      <li>
        <img src="../assets/img/fu-cen5.png" alt="运营服务">
        <h4>运营服务</h4>
        <p>借助自身专业的运营团队、广泛的线上资源调度能力和丰富的运营经验，为运营商客户提供互联网运营支撑及代运营服务，全力助力运营商运营互联化。</p>
      </li>
      <li>
        <img src="../assets/img/fu-cen6.png" alt="敬请期待">
        <h4>敬请期待</h4>
      </li>
    </ul>
    <img src="../assets/img/fu-footer.png" alt="五大服务项目" class="cenFbg">
    <p class="beianPtips"><span @click="goBeian">陕ICP备15007224号</span></p>
  </div>
</template>

<script>
  export default {
  	name: 'indexCenterF',
  	data () {
  		return {

  		}
  	},
    mounted:function(){

    },
  	methods:{
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
  	}
  }
</script>

<style scoped lang="scss">
  .indeCenF{
    padding-bottom: 13rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .beianPtips{
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
      color: #3a3a3a;
      text-align: center;
      span:hover{
        color: #000;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    h2{
      margin: 4rem 0;
      font-weight: 100;
    }
    ul{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 65%;
      z-index: 1;
      li{
        width: 33%;
        margin: .2rem 0;
        height: 15rem;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: #efefef 0 0 1rem .2rem;
        img{
          width: 2rem;
          margin: 1.8rem auto 0;
        }
        h4{
          margin: .8rem 0;
        }
        p{
          color: #a4a4a4;
          padding: 0 3.2rem;
          text-align: justify;
          text-indent: 2rem;
          font-size: .9rem;
          line-height: 1.4rem;
        }
      }
      li:nth-of-type(6) img{
        margin-top: 5rem;
      }
    }
    .cenFbg{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    @media screen and (max-width: 1800px) {
      ul{
        width:80%;
      }
    }
    @media screen and (max-width: 1550px) {
      ul{
        li{
          p{
            padding: 0 2rem;
          }
        }
      }
    }
    @media screen and (max-width: 1300px) {
      ul{
        width:90%;
      }
    }
    @media screen and (max-width: 1100px) {
      ul{
        li{
          width: 48%;
        }
      }
    }
    @media screen and (max-width: 800px) {
      padding-bottom: 3rem;
      h2{
        margin: 2rem 0;
      }
      ul{
        li{
          width: 100%;
        }
      }
      .beianPtips{
        bottom: 1rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexCenterF.vue